import { FC } from 'react';

import './Charts.scss';

type FooterChartProps = {
    axisName: string,
    columnNames: string[],
};

const FooterChart: FC<FooterChartProps> = ({ axisName, columnNames }) => {
    return <div className="footer-chart">
        {columnNames && columnNames.length > 0 && 
            <div className="footer-chart_columns">
                {columnNames.map((column: string, index:number) => {
                    return <div key={index} className="footer-chart_columns_column">{column}</div>
                })}
            </div>
        }
        {axisName && <div className="footer-chart_axis">{axisName}</div>}
    </div>
};

export default FooterChart;
